import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { getOnlineStreams } from "../../../actions/stream";

import OnlineUserItem from "./OnlineUserItem";

const OnlineUsers = ({
  auth: { isAuthenticated, user },
  stream: { livestreams },
  getOnlineStreams,
}) => {
  useEffect(() => {
    getOnlineStreams();
  }, [getOnlineStreams]);

  return (
    <Fragment>
      {user && user.role === "innovator" && (
        <div className="online-recommended">
          <div className="online-title-container-alt">
            {isAuthenticated && (
              <div className="border-alt green">
                <p className="online-title-alt green">
                  <i className="fas fa-wifi green mr-5"></i>Online
                </p>
              </div>
            )}
            {!isAuthenticated && (
              <div className="border-alt green">
                <p className="online-title-alt green">
                  <i className="far fa-user green mr-5"></i>Recommended
                </p>
              </div>
            )}
          </div>
          {livestreams && livestreams.length > 0 ? (
            livestreams.map((user) => {
              return <OnlineUserItem key={user.channelid} user={user} />;
            })
          ) : (
            <div className="empty-side-container">
              <p className="empty-content-alt-dark-user green bold">
                No Friends Online
              </p>
            </div>
          )}
        </div>
      )}
      {user && user.role === "mentor" && (
        <div className="online-recommended">
          <div className="online-title-container-alt">
            {isAuthenticated && (
              <div className="border-alt red">
                <p className="online-title-alt red">
                  <i className="fas fa-wifi red mr-5"></i>Online
                </p>
              </div>
            )}
            {!isAuthenticated && (
              <div className="border-alt red">
                <p className="online-title-alt red">
                  <i className="far fa-user red mr-5"></i>Recommended
                </p>
              </div>
            )}
          </div>
          {livestreams && livestreams.length > 0 ? (
            livestreams.map((user) => {
              return <OnlineUserItem key={user.channelid} user={user} />;
            })
          ) : (
            <div className="empty-side-container">
              <p className="empty-content-alt-dark red bold">
                No Friends Online
              </p>
            </div>
          )}
        </div>
      )}
      {user && user.role === "employer" && (
        <div className="online-recommended">
          <div className="online-title-container-alt">
            {isAuthenticated && (
              <div className="border-alt blue">
                <p className="online-title-alt blue">
                  <i className="fas fa-wifi blue mr-5"></i>Online
                </p>
              </div>
            )}
            {!isAuthenticated && (
              <div className="border-alt blue">
                <p className="online-title-alt blue">
                  <i className="far fa-user blue mr-5"></i>Recommended
                </p>
              </div>
            )}
          </div>
          {livestreams && livestreams.length > 0 ? (
            livestreams.map((user) => {
              return <OnlineUserItem key={user.channelid} user={user} />;
            })
          ) : (
            <div className="empty-side-container">
              <p className="empty-content-alt-dark blue bold">
                No Friends Online
              </p>
            </div>
          )}
        </div>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  stream: state.stream,
});

export default connect(mapStateToProps, { getOnlineStreams })(OnlineUsers);
